require.register("app/restaurant/ListView", function(exports, require, module){
  $0
  
});

